import { Card, CardBody, Col } from "reactstrap";
import { ButtonsWithPrefixPostfixTitle } from "../../../../../constants";
import CommonPrefixAndPostfix from "./common/CommonPrefixAndPostfix";
import { TouchSpinSubTitle } from "../../../../../data/formsAndTable/forms/FormWidgets";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const ButtonsWithPrefixPostfix = () => {
  return (
    <Col xl="6">
      <Card className="custom-prefix">
        <CommonCardHeader title={ButtonsWithPrefixPostfixTitle} span={TouchSpinSubTitle} />
        <CardBody className="common-flex pre-post-touchspin bg-touchspin">
          <CommonPrefixAndPostfix preButton color />
          <CommonPrefixAndPostfix PostButton color />
        </CardBody>
      </Card>
    </Col>
  );
};
export default ButtonsWithPrefixPostfix;
